import queryString from 'query-string';
export function buildCreateLegacyComposerInviteesParam(_a) {
    var _b;
    var invitees = _a.invitees, attendeeCount = _a.attendeeCount, isSpaceRequestOnlyEvent = _a.isSpaceRequestOnlyEvent, currentUserId = _a.currentUserId;
    var hasMultipleInvitees = ((_b = invitees === null || invitees === void 0 ? void 0 : invitees.length) !== null && _b !== void 0 ? _b : 0) > 1;
    var hasEstimatedInvitees = !!attendeeCount && isSpaceRequestOnlyEvent;
    if (!hasMultipleInvitees && !hasEstimatedInvitees) {
        return '';
    }
    if (isSpaceRequestOnlyEvent) {
        return "&inviteeCount=".concat(attendeeCount);
    }
    if (!invitees) {
        return '';
    }
    return "&".concat(invitees
        .filter(function (invitee) { return invitee.user_id !== currentUserId; })
        .map(function (invitee) { return "invitees=".concat(invitee.email); })
        .join('&'));
}
export function buildCreateLegacyComposerUrl(params) {
    var dashboardUrl = params.dashboardUrl, title = params.title, isPrivateEvent = params.isPrivateEvent, orgId = params.orgId, startTime = params.startTime, endTime = params.endTime, spaceId = params.spaceId, redirectTo = params.redirectTo, uid = params.uid, timezone = params.timezone, isAllDayEvent = params.isAllDayEvent, invitees = params.invitees, attendeeCount = params.attendeeCount, isSpaceRequestOnlyEvent = params.isSpaceRequestOnlyEvent, currentUserId = params.currentUserId;
    var queryParams = {
        title: title,
        is_private: isPrivateEvent,
        org: orgId,
        started_at: startTime === null || startTime === void 0 ? void 0 : startTime.toJSON(),
        ended_at: endTime === null || endTime === void 0 ? void 0 : endTime.toJSON(),
        space_id: spaceId,
        redirectTo: redirectTo,
        uid: uid,
        timezone: timezone,
        isAllDay: !!isAllDayEvent,
    };
    var inviteesParam = buildCreateLegacyComposerInviteesParam({
        invitees: invitees,
        attendeeCount: attendeeCount,
        isSpaceRequestOnlyEvent: isSpaceRequestOnlyEvent,
        currentUserId: currentUserId,
    });
    return "".concat(dashboardUrl, "/event-composer?").concat(queryString.stringify(queryParams)).concat(inviteesParam);
}
export function buildEditLegacyComposerUrl(params) {
    var dashboardUrl = params.dashboardUrl, eventId = params.eventId, title = params.title, orgId = params.orgId, startTime = params.startTime, endTime = params.endTime, spaceId = params.spaceId, redirectTo = params.redirectTo, attendeeCount = params.attendeeCount, timezone = params.timezone, isAllDayEvent = params.isAllDayEvent;
    var queryParams = {
        title: title,
        org: orgId,
        started_at: startTime === null || startTime === void 0 ? void 0 : startTime.toJSON(),
        ended_at: endTime === null || endTime === void 0 ? void 0 : endTime.toJSON(),
        space_id: spaceId,
        redirectTo: redirectTo,
        inviteeCount: attendeeCount,
        timezone: timezone,
        isAllDay: !!isAllDayEvent,
    };
    return "".concat(dashboardUrl, "/event-composer/").concat(eventId, "?").concat(queryString.stringify(queryParams));
}
